export enum SnackbarType {
  Default = 0,
  Error = 1,
  Success = 2,
}
